import React from "react";
import { X, Heart, Sparkles } from "lucide-react";

// Simple diegetic memory card shown when a non-game object is discovered.
export const FindMemoryCard = ({ find, found, onClose, onAdd }) => {
  if (!find) return null;
  return (
    <div
      data-testid="find-memory-card"
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="card-in relative w-full max-w-sm rounded-xl border-[4px] border-kirana-brown bg-kirana-cream p-5 hard-shadow"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="find-close"
          onClick={onClose}
          className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full border-2 border-kirana-brown bg-kirana-cream text-kirana-brown transition-transform hover:scale-110"
        >
          <X className="h-4 w-4" strokeWidth={3} />
        </button>

        <div className="mb-2 flex items-center gap-1.5 text-kirana-red">
          <Sparkles className="h-4 w-4" strokeWidth={2.5} />
          <span className="font-signboard text-xs font-bold uppercase tracking-wide">Ek Purani Cheez Mili</span>
        </div>

        <h2 className="font-signboard text-2xl font-bold leading-tight text-kirana-brown">{find.name}</h2>
        {find.need && <p className="mt-0.5 text-[11px] font-bold text-kirana-brown/60">{find.need}</p>}

        <p className="mt-3 rounded-md border-2 border-dashed border-kirana-brown/40 bg-white/50 p-3 text-sm italic leading-relaxed text-kirana-brown">
          “{find.blurb}”
        </p>

        {found ? (
          <div className="mt-4 flex items-center justify-center gap-1.5 rounded-md border-2 border-kirana-green bg-kirana-green/10 py-2 font-bold text-kirana-green">
            <Heart className="h-4 w-4 fill-kirana-green" /> Yaad sambhal li!
          </div>
        ) : (
          <button
            data-testid="find-add-memory"
            onClick={() => onAdd(find.key)}
            className="mt-4 flex w-full items-center justify-center gap-2 rounded-md border-2 border-kirana-brown bg-kirana-gold py-2.5 font-signboard font-bold text-kirana-brown transition-transform hover:scale-[1.02] hard-shadow-sm"
          >
            <Heart className="h-4 w-4" /> Yeh Yaad Sambhaal Lo
          </button>
        )}
      </div>
    </div>
  );
};
